import {
    FETCH_CURRENCY_RATES,
    FETCH_CURRENCY_RATES_SUCCESS,
    FETCH_CURRENCY_RATES_FAIL,
} from '../../types';

const initialState = {
    loading: false,
    error: null,
    currencyRates: null
};

export const currenciesReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case FETCH_CURRENCY_RATES:
            return {
                ...state,
                loading: true
            };
        case FETCH_CURRENCY_RATES_SUCCESS:
            return {
                ...state,
                loading: false,
                currencyRates: action.payload,
                error: null
            };
        case FETCH_CURRENCY_RATES_FAIL:
            return {
                ...state,
                loading: false,
                currencyRates: null,
                error: action.payload
            };
        default:
            return state;
    }
};